const dummyHomepageSubjectCards = [
  {
    name: 'Homepage Subject List: Computer Science',
    title: 'Computer Science',
    cardList: [
      'ae17a348-78ed-496e-a0b7-a1c7098a3ad0',
      '911175d0-6724-4276-a058-c7b052773dd1',
      '5a631d1c-cb20-4cfc-9b49-1cc9c8fc981e',
      'e540320a-f125-4021-8f1c-9cbc84c96d87',
      '5f0e63ca-98e1-4886-9b88-9e2aa492895c',
    ],
    cta: {
      label: 'Explore more computer science courses',
      url: '/course/subject/computer-science',
      isExternal: false,
    },
    programType: null,
  },
  {
    name: 'Homepage Subject List: Business',
    title: 'Business',
    cardList: [
      '6774d438-134f-4d20-95a2-ea763f59ff23',
      '327c8e4f-315a-417b-9857-046dfc90c243',
      '66d85856-511a-43e8-98b8-3acc4da8d275',
      'ab26a0c8-003e-4a61-9f18-0f0395c3b4c6',
    ],
    cta: {
      label: 'Explore more business courses',
      url: '/course/subject/business-management',
      isExternal: false,
    },
    programType: null,
  },
];

const dummyHomepageCourseUUIDs = [
  'ae17a348-78ed-496e-a0b7-a1c7098a3ad0',
  '911175d0-6724-4276-a058-c7b052773dd1',
  '5a631d1c-cb20-4cfc-9b49-1cc9c8fc981e',
  'e540320a-f125-4021-8f1c-9cbc84c96d87',
  '5f0e63ca-98e1-4886-9b88-9e2aa492895c',
  '6774d438-134f-4d20-95a2-ea763f59ff23',
  '327c8e4f-315a-417b-9857-046dfc90c243',
  '66d85856-511a-43e8-98b8-3acc4da8d275',
  'ab26a0c8-003e-4a61-9f18-0f0395c3b4c6',
  '3a31db71-de8f-45f1-ae65-11981ed9d680', // AI Course (meganav)
  'a69081ed-907a-4755-8779-b1fa7b1e10b2',
  '4ce9c976-11cc-43e3-925e-ba0c61507b29',
  '08acc095-2ad8-4922-aa5d-7ad909c4de48',
  'd1a1d914-2238-4733-8737-e0723ec233c7',
];

const storeFrontCoursesUUIDs = [
  'ae17a348-78ed-496e-a0b7-a1c7098a3ad0', // learn/web-development/ibm-introduction-to-web-development-with-html5-css3-and-javascript
  '911175d0-6724-4276-a058-c7b052773dd1', // learn/python/the-university-of-michigan-programming-for-everybody-getting-started-with-python
  '5a631d1c-cb20-4cfc-9b49-1cc9c8fc981e', // learn/linux/the-linux-foundation-introduction-to-linux
  '66d85856-511a-43e8-98b8-3acc4da8d275', // learn/operations-management/indian-institute-of-management-bangalore-operations-management
  '5f0e63ca-98e1-4886-9b88-9e2aa492895c', // learn/entrepreneurship/massachusetts-institute-of-technology-becoming-an-entrepreneur
  'da1b2400-322b-459b-97b0-0c557f05d017', // learn/computer-science/harvard-university-cs50-s-introduction-to-computer-science
  '4ce9c976-11cc-43e3-925e-ba0c61507b29', // learn/agile-project-management/inter-american-development-bank-pm4r-agile-agile-mindset-in-development-projects
  'e540320a-f125-4021-8f1c-9cbc84c96d87', // learn/python/the-georgia-institute-of-technology-computing-in-python-i-fundamentals-and-procedural-programming
  '08acc095-2ad8-4922-aa5d-7ad909c4de48', // learn/design-thinking/university-of-maryland-global-campus-instructional-design-digital-media-new-tools-and-technology
  'd1a1d914-2238-4733-8737-e0723ec233c7', // learn/computer-programming/delft-university-of-technology-introduction-to-functional-programming
];

const storeFrontExecEdUUIDs = [
  '32ab61e5-44b4-4316-ad59-9f04fc876e0a', // /executive-education/massachusetts-institute-of-technology-artificial-intelligence-implications-for-business-strategy
  'f1e7155d-81ea-4446-96a8-a0562da1934e', // /executive-education/harvard-university-fintech
  'a69081ed-907a-4755-8779-b1fa7b1e10b2', // /executive-education/university-of-oxford-artificial-intelligence-programme
  'ac0779b0-d342-42c4-99b3-d2c2ff93f980', // /executive-education/the-london-school-of-economics-and-political-science-ethics-of-ai
];

// /learn/business-administration/the-georgia-institute-of-technology-data-analytics-for-business
const singleTestCourseUUID = '1e2cae8c-1c67-4067-a3c0-360543e6a9b8';

// /learn/art/tsinghua-university-western-and-chinese-art-masters-and-classics
const singleTestArchivedCourseUUID = '876a65e7-425b-437b-bced-bdf8059fec81';

// /learn/computer-programming/microsoft-introduction-to-c-3
const singleTestUnenrollableCourseUUID = '72abaeb3-0856-4e89-906a-8b6eef402a1f';

// /learn/supply-chain-design/massachusetts-institute-of-technology-supply-chain-fundamentals
const courseWithRedirectUUID = '324970b7-03a4-44d7-b39e-10bbda6f119f';

// /micromasters/ubcx-software-development - this one has all the graphql fields
const singleDataPlaceholderProgramUUID = 'a78e76d2-7e0b-4865-8013-0e037ebdc0f9';

// /masters/micromasters/ritx-cybersecurity
const singleTestProgramUUID = '8ac6657e-a06a-4a47-aba7-5c86b5811fa1';

// /executive-education/massachusetts-institute-of-technology-artificial-intelligence-implications-for-business-strategy
const singleTestExecEdCourseUUID = '32ab61e5-44b4-4316-ad59-9f04fc876e0a';

const singleTestProgramCourseUUIDs = [
  'da1b2400-322b-459b-97b0-0c557f05d017',
  '8d1da557-03db-4175-b881-e0480d706d96',
];

//    * twoTrackProgramUUID: The original MIT SDS program; this is the page
//      that will be built differently
//    * linkedProgramUUID: The additonal program that has the data we want
//      to pass to PROGRAM_1 as the "linkedProgram"

// /micromasters/mitx-statistics-and-data-science
const twoTrackProgramUUID = '71c95834-f6df-4f78-8cd7-c6461dd9b1d4';

const twoTrackProgramCourseUUIDs = [
  '84251067-b212-4355-a9d3-246d91896b90',
  '48708e7e-0152-4a4b-ad4c-2dadce29c87f',
  '54f10d8d-e1cd-44a9-9fe3-af78afe8a9ed',
  '4c70ad9b-9602-49af-bf00-83fa4bf47708',
  'd8d3c316-0e41-4083-93ff-733a7e9b16bb',
];

const linkedProgramUUID = 'fa06b9c5-fe2b-41d8-a8c1-1bfd9c0d7b07';

const linkedProgramCourseUUIDs = [
  '54f10d8d-e1cd-44a9-9fe3-af78afe8a9ed',
  '124fb823-86b0-4ec1-8892-51496ce3c605',
  '84251067-b212-4355-a9d3-246d91896b90',
  '4c70ad9b-9602-49af-bf00-83fa4bf47708',
];

// example resource page
const singleResourcePageSlug = 'example-resource-page';

// /masters/online-master-in-supply-chain-management-asux
const singleMastersProgramUUID = '2b4fb318-5bec-4484-9b6f-e279fa0f4693';

const limitedMastersDegreeUUIDs = [
  '89f39d1a-bb23-4944-b6e0-b51fe25ce932', // /masters/online-master-artificial-intelligence-utaustinx
  '4a5f20a5-0306-4c5a-89b6-f3013d8ce2f4', // /masters/online-master-in-nutritional-sciences-utaustin (FLEX)
  '1aba4bff-9a0f-4b37-99b3-60a4c04a873f', // /masters/mba/online-master-business-administration-mba-bux
  'fae3cd5c-3a1e-407d-ad96-2dce117d49c4', // /masters/maryville-university-master-of-arts-in-strategic-communication-and-leadership
];
const limitedBachelorsDegreeUUIDs = [
  '123f9327-bfef-459f-8bf2-c53277aa58f8', // /bachelors/bachelor-of-science-in-data-science-and-business-analytics
];
const limitedDoctorateDegreeUUIDs = [
  'd268ea95-43f2-4d98-9abb-21ceecc70cf8', // /doctorate/online-edd-programs/usc-doctor-of-education-in-organizational-change-and-leadership
];
const singleContentfulTopicNameEN = 'Macroeconometric Forecasting';
const singleContentfulTopicNameES = 'Electricidad';
// example modular page with all module types
const singleModularPageSlug = 'modular-template';

// example learn page
const singleLearnPageSlug = 'example-learn-page';

// example subcategory page
const singleSubcategoryPageSlug = 'subcategory-example';

// /school/harvardx
const singleSchoolUUID = '44022f13-20df-4666-9111-cede3e5dc5b6';

const storeFrontProgramUUIDs = [
  'fa06b9c5-fe2b-41d8-a8c1-1bfd9c0d7b07', // /secure-preview/storefront/masters/micromasters/mitx-statistics-and-data-science-general-track
  '64b3c632-8610-4b17-9a48-9efee7fa3266', // /secure-preview/storefront/certificates/professional-certificate/harvardx-computer-science-for-game-development
  '71c95834-f6df-4f78-8cd7-c6461dd9b1d4', // /secure-preview/storefront/masters/micromasters/mitx-statistics-and-data-science
];

// example product landing page
const singleProductLanding = 'example-product-landing';

module.exports = {
  dummyHomepageSubjectCards,
  dummyHomepageCourseUUIDs,
  singleDataPlaceholderProgramUUID,
  singleTestCourseUUID,
  singleTestArchivedCourseUUID,
  singleTestUnenrollableCourseUUID,
  singleTestExecEdCourseUUID,
  courseWithRedirectUUID,
  singleTestProgramUUID,
  singleResourcePageSlug,
  limitedBachelorsDegreeUUIDs,
  limitedDoctorateDegreeUUIDs,
  singleMastersProgramUUID,
  singleTestProgramCourseUUIDs,
  singleContentfulTopicNameEN,
  singleContentfulTopicNameES,
  singleModularPageSlug,
  singleLearnPageSlug,
  singleSubcategoryPageSlug,
  singleSchoolUUID,
  twoTrackProgramUUID,
  twoTrackProgramCourseUUIDs,
  linkedProgramUUID,
  linkedProgramCourseUUIDs,
  limitedMastersDegreeUUIDs,
  singleProductLanding,
  storeFrontCoursesUUIDs,
  storeFrontProgramUUIDs,
  storeFrontExecEdUUIDs,
};
